import { SectionDimensionsPage } from "./SectionDimensionsPage";

const SectionDimensions = () => {
	return <SectionDimensionsPage />;
};

export default SectionDimensions;
